import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import {TreeviService} from './treevi.service';
import { TreeviModel } from '../treev.model';

@Component({
  selector: 'app-treevi',
  templateUrl: './treevi.component.html'
})
export class TreeviComponent implements OnInit {
  @Input() model: TreeviModel[]

  constructor(public service: TreeviService) { }

  ngOnInit(): void {
  }

  expand (trvi: TreeviModel){
    if (trvi.cnf.exp==0) trvi.cnf.exp = 1
    else trvi.cnf.exp = 0
  }
}
